import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TokenInterceptor } from "./interceptors/token.interceptor";
import { HeaderInterceptor } from "./interceptors/header.interceptor";
import { LookerService } from "./services/looker.service";
import { WindowRefService } from "./services/window-ref.service";
import * as Sentry from "@sentry/angular";

// Material modules
import { MatTabsModule } from "@angular/material/tabs";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { LocalizationTimezoneInterceptor } from "./interceptors/localization.timezone.interceptor";
import { Router } from "@angular/router";

@NgModule({
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppComponent,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatProgressBarModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LocalizationTimezoneInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    LookerService,
    provideHttpClient(withInterceptorsFromDi()),
    WindowRefService,
  ],
})
export class AppModule {}
